/* lf-product-tabs — WAI-ARIA tabs, one panel visible at a time.

   Roving tabindex: only the selected tab is in the tab order, and Left/Right/
   Home/End move between tabs. Panels carry `hidden`; the incoming one is
   unhidden with data-enter set for a single frame so CSS can crossfade it. */
(function () {
  var ROOT = '[data-lf-tabs]';
  var TAB = '[data-lf-tab]';
  var MEDIA = '[data-lf-tab-media]';

  function panelFor(tab) {
    var id = tab.getAttribute('aria-controls');
    return id ? document.getElementById(id) : null;
  }

  // Reveal one element and hide its siblings, with the same two-frame
  // data-enter handoff the panels use so CSS owns the crossfade.
  function reveal(items, target) {
    items.forEach(function (item) {
      if (item !== target) {
        item.hidden = true;
        delete item.dataset.enter;
        return;
      }

      if (!item.hidden) return;

      item.hidden = false;
      item.dataset.enter = 'true';
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          delete item.dataset.enter;
        });
      });
    });
  }

  /* A tab can carry its own photo in the media column (Cut of Meat shows the
     cut, everything else falls back to the animal engraving). The media lives
     outside the tablist, so it is found on the section rather than the root,
     and a section with no media simply no-ops. */
  function selectMedia(root, tab) {
    var section = root.closest ? root.closest('.lf-product-tabs') : null;
    if (!section) return;

    var items = Array.prototype.slice.call(section.querySelectorAll(MEDIA));
    if (!items.length) return;

    var key = tab.getAttribute('data-lf-tab-media-key');
    var wanted = null;
    var fallback = null;

    items.forEach(function (item) {
      var itemKey = item.getAttribute('data-lf-tab-media');
      if (itemKey === 'default') fallback = item;
      if (key && itemKey === key) wanted = item;
    });

    reveal(items, wanted || fallback);
  }

  function select(root, tab, focusTab) {
    var tabs = Array.prototype.slice.call(root.querySelectorAll(TAB));

    tabs.forEach(function (candidate) {
      var isTarget = candidate === tab;
      var panel = panelFor(candidate);

      candidate.setAttribute('aria-selected', isTarget ? 'true' : 'false');
      candidate.setAttribute('tabindex', isTarget ? '0' : '-1');

      if (!panel) return;

      if (isTarget) {
        if (panel.hidden) {
          panel.hidden = false;
          panel.dataset.enter = 'true';
          // Two frames: one to commit the hidden -> shown box, one to drop the
          // start state so the opacity transition actually has a from-value.
          requestAnimationFrame(function () {
            requestAnimationFrame(function () {
              delete panel.dataset.enter;
            });
          });
        }
      } else {
        panel.hidden = true;
        delete panel.dataset.enter;
      }
    });

    selectMedia(root, tab);

    if (focusTab) {
      tab.focus();
      // Arrow keys can land on a tab that is off the end of the mobile bar,
      // which scrolls sideways once the labels outrun the content column.
      // Focus alone does not always bring it back into view, so the track is
      // nudged the minimum distance. 'nearest' on both axes keeps the page
      // itself still when the tab is already on screen.
      if (tab.scrollIntoView) tab.scrollIntoView({ block: 'nearest', inline: 'nearest' });
    }
  }

  function onKeydown(root, event) {
    var tabs = Array.prototype.slice.call(root.querySelectorAll(TAB));
    var current = tabs.indexOf(event.target);
    if (current === -1) return;

    var next = -1;

    switch (event.key) {
      case 'ArrowRight':
        next = (current + 1) % tabs.length;
        break;
      case 'ArrowLeft':
        next = (current - 1 + tabs.length) % tabs.length;
        break;
      case 'Home':
        next = 0;
        break;
      case 'End':
        next = tabs.length - 1;
        break;
      default:
        return;
    }

    event.preventDefault();
    select(root, tabs[next], true);
  }

  function init(root) {
    if (!root || root.dataset.lfTabsReady === 'true') return;
    root.dataset.lfTabsReady = 'true';

    root.addEventListener('click', function (event) {
      var tab = event.target.closest ? event.target.closest(TAB) : null;
      if (tab && root.contains(tab)) select(root, tab, false);
    });

    root.addEventListener('keydown', function (event) {
      onKeydown(root, event);
    });
  }

  function initAll(scope) {
    (scope || document).querySelectorAll(ROOT).forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  // Selecting a tab block in the theme editor opens it, so the merchant sees
  // the panel they are editing. The block element IS the tab button, so match
  // it directly before looking inside.
  document.addEventListener('shopify:block:select', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;

    var tab = target.matches(TAB) ? target : target.querySelector(TAB);
    if (!tab) return;

    var root = tab.closest(ROOT);
    if (root) select(root, tab, false);
  });
})();
